<template lang="">
  <section
    v-if="categories.length > 0"
    class="mt-4 mt-lg-5 px-3 px-lg-0 explore-by-categories"
  >
    <h2 class="text-secondary title">Explora por categorías</h2>
    <div class="row">
      <div class="col-12 col-lg-11">
        <swiper
          :modules="modules"
          :navigation="false"
          :loop="false"
          :free-mode="true"
          :breakpoints="{
            '320': {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            '640': {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            '768': {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            '992': {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            '1280': {
              slidesPerView: 7,
              spaceBetween: 10,
            },
            '1440': {
              slidesPerView: 9,
              spaceBetween: 10,
            },
          }"
          class="p-0 w-100"
        >
          <swiper-slide
            v-for="(category, index) in categories"
            :key="index"
            class="swiper-category"
          >
            <link-category :category="category" />
          </swiper-slide>
        </swiper>
      </div>
      <div class="col-lg-1 d-none d-lg-block">
        <link-category
          class="ms-2 align-self-stretch"
          :style="{ width: '100px !important' }"
          :category="categorySeeMore"
        />
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { Swiper, SwiperSlide } from "swiper/vue";
import { HomeService } from "@/services/HomeService";
import { store } from "~/store";
import LinkCategory from "@/components/buttons/LinkCategory.vue";

// import required modules
import {
  Navigation,
  FreeMode,
  Pagination,
  Scrollbar,
  A11y,
  EffectFade,
} from "swiper/modules";

export default {
  components: {
    Swiper,
    SwiperSlide,
    LinkCategory,
  },
  setup() {
    return {
      modules: [Pagination, Scrollbar, A11y, Navigation, EffectFade, FreeMode],
    };
  },
  computed: {
    categories() {
      let categoriesDeserialize =
        store.getters["catalogs/getDeserealizeCategories"];
      if (!categoriesDeserialize) {
        return [];
      }
      return categoriesDeserialize;
    },
    categorySeeMore() {
      return {
        id: 0,
        name: "Ver todas",
        iconSwiper: "bi-chevron-double-right",
        links: {
          self: "/busqueda-por-categoria",
        },
      };
    },
  },
  mounted() {
    const homeService = new HomeService();
    const categories = store.getters["catalogs/getCategories"];
    if (categories == undefined || categories.data.length == 0) {
      homeService.getCategories();
    }
  },
};
</script>
<style lang="scss" scoped>
.swiper-category {
  font-size: 16px !important;
}
</style>
